import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './BusinessMastersSwitch.css';

export type ViewMode = 'business' | 'masters';

interface BusinessMastersSwitchProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const BusinessMastersSwitch: React.FC<BusinessMastersSwitchProps> = ({
  viewMode,
  onViewModeChange
}) => {
  const { language } = useLanguage();

  const handleModeChange = (mode: ViewMode) => {
    onViewModeChange(mode);
    // Зберігаємо вибір в localStorage
    localStorage.setItem('public_view_mode', mode);
  };

  return (
    <div className="business-masters-switch" role="group" aria-label="Перемикання режиму перегляду">
      <button
        className={`switch-button ${viewMode === 'business' ? 'active' : ''}`}
        onClick={() => handleModeChange('business')}
        aria-pressed={viewMode === 'business'}
        aria-label="Перегляд бізнесів"
      >
        <i className="bi bi-building" aria-hidden="true"></i>
        <span>{language === 'ua' ? 'Бізнеси' : 'Business'}</span>
      </button>
      
      <button
        className={`switch-button ${viewMode === 'masters' ? 'active' : ''}`}
        onClick={() => handleModeChange('masters')}
        aria-pressed={viewMode === 'masters'}
        aria-label="Перегляд майстрів"
      >
        <i className="bi bi-person-badge" aria-hidden="true"></i>
        <span>{language === 'ua' ? 'Майстри' : 'Masters'}</span>
      </button>
    </div>
  );
};

export default BusinessMastersSwitch;
